"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DataTableController", {
    enumerable: true,
    get: function() {
        return DataTableController;
    }
});
const _common = require("@nestjs/common");
const _express = require("express");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _datatableservice = require("~/services/data-table.service");
const _helpers = require("~/helpers");
const _dataapilimiterguard = require("~/guards/data-api-limiter.guard");
const _globalguard = require("~/guards/global/global.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let DataTableController = class DataTableController {
    // todo: Handle the error case where view doesnt belong to model
    async dataList(context, req, res, modelId, viewId, includeSortAndFilterColumns) {
        context.cache = true;
        const startTime = process.hrtime();
        const responseData = await this.dataTableService.dataList(context, {
            query: req.query,
            modelId: modelId,
            viewId: viewId,
            includeSortAndFilterColumns: includeSortAndFilterColumns === 'true',
            user: req.user
        });
        const elapsedSeconds = (0, _helpers.parseHrtimeToMilliSeconds)(process.hrtime(startTime));
        res.setHeader('xc-db-response', elapsedSeconds);
        res.json(responseData);
    }
    async dataCount(context, req, res, modelId, viewId) {
        context.cache = true;
        const countResult = await this.dataTableService.dataCount(context, {
            query: req.query,
            modelId,
            viewId,
            user: req.user
        });
        res.json(countResult);
    }
    async dataInsert(context, req, modelId, viewId, body, undo) {
        return await this.dataTableService.dataInsert(context, {
            modelId: modelId,
            body: body,
            viewId,
            cookie: req,
            undo: undo === 'true',
            user: req.user
        });
    }
    async dataUpdate(context, req, modelId, viewId, _rowId) {
        return await this.dataTableService.dataUpdate(context, {
            modelId: modelId,
            body: req.body,
            cookie: req,
            viewId,
            user: req.user
        });
    }
    async dataDelete(context, req, modelId, viewId, _rowId) {
        return await this.dataTableService.dataDelete(context, {
            modelId: modelId,
            cookie: req,
            viewId,
            body: req.body,
            user: req.user
        });
    }
    async dataAggregate(context, req, modelId, viewId) {
        context.cache = true;
        return await this.dataTableService.dataAggregate(context, {
            query: req.query,
            modelId,
            viewId,
            user: req.user
        });
    }
    async bulkGroupBy(context, req, modelId, viewId) {
        return await this.dataTableService.bulkGroupBy(context, {
            query: req.query,
            modelId,
            viewId,
            body: req.body,
            user: req.user
        });
    }
    async bulkDataList(context, req, modelId, viewId) {
        return await this.dataTableService.bulkDataList(context, {
            query: req.query,
            modelId,
            viewId,
            body: req.body,
            user: req.user
        });
    }
    async dataRead(context, req, modelId, viewId, rowId) {
        context.cache = true;
        return await this.dataTableService.dataRead(context, {
            modelId,
            rowId: rowId,
            query: req.query,
            viewId,
            user: req.user
        });
    }
    async rowMove(context, req, modelId, rowId, before) {
        return await this.dataTableService.dataMove(context, {
            modelId: modelId,
            rowId: rowId,
            beforeRowId: before,
            cookie: req,
            user: req.user
        });
    }
    async nestedDataList(context, req, modelId, viewId, columnId, rowId) {
        context.cache = true;
        return await this.dataTableService.nestedDataList(context, {
            modelId,
            rowId: rowId,
            query: req.query,
            viewId,
            columnId,
            user: req.user
        });
    }
    async nestedLink(context, req, modelId, viewId, columnId, rowId, refRowIds) {
        return await this.dataTableService.nestedLink(context, {
            modelId,
            rowId: rowId,
            query: req.query,
            viewId,
            columnId,
            refRowIds,
            cookie: req,
            user: req.user
        });
    }
    async nestedUnlink(context, req, modelId, viewId, columnId, rowId, refRowIds) {
        return await this.dataTableService.nestedUnlink(context, {
            modelId,
            rowId: rowId,
            query: req.query,
            viewId,
            columnId,
            refRowIds,
            cookie: req,
            user: req.user
        });
    }
    // todo: naming
    async nestedListCopyPasteOrDeleteAll(context, req, modelId, viewId, columnId, data) {
        return await this.dataTableService.nestedListCopyPasteOrDeleteAll(context, {
            modelId,
            query: req.query,
            viewId,
            columnId,
            data,
            cookie: req,
            user: req.user
        });
    }
    async bulkAggregate(context, req, modelId, viewId) {
        context.cache = true;
        return await this.dataTableService.bulkAggregate(context, {
            query: req.query,
            modelId,
            viewId,
            body: req.body
        });
    }
    constructor(dataTableService){
        this.dataTableService = dataTableService;
    }
};
_ts_decorate([
    (0, _common.Get)('/api/v2/tables/:modelId/records'),
    (0, _extractidsmiddleware.Acl)('dataList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Res)()),
    _ts_param(3, (0, _common.Param)('modelId')),
    _ts_param(4, (0, _common.Query)('viewId')),
    _ts_param(5, (0, _common.Query)('includeSortAndFilterColumns')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        typeof _express.Response === "undefined" ? Object : _express.Response,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataTableController.prototype, "dataList", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v2/tables/:modelId/records/count'
    ]),
    (0, _extractidsmiddleware.Acl)('dataCount'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Res)()),
    _ts_param(3, (0, _common.Param)('modelId')),
    _ts_param(4, (0, _common.Query)('viewId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        typeof _express.Response === "undefined" ? Object : _express.Response,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataTableController.prototype, "dataCount", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v2/tables/:modelId/records'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('dataInsert'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('modelId')),
    _ts_param(3, (0, _common.Query)('viewId')),
    _ts_param(4, (0, _common.Body)()),
    _ts_param(5, (0, _common.Query)('undo')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        Object,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], DataTableController.prototype, "dataInsert", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v2/tables/:modelId/records'
    ]),
    (0, _extractidsmiddleware.Acl)('dataUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('modelId')),
    _ts_param(3, (0, _common.Query)('viewId')),
    _ts_param(4, (0, _common.Param)('rowId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataTableController.prototype, "dataUpdate", null);
_ts_decorate([
    (0, _common.Delete)([
        '/api/v2/tables/:modelId/records'
    ]),
    (0, _extractidsmiddleware.Acl)('dataDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('modelId')),
    _ts_param(3, (0, _common.Query)('viewId')),
    _ts_param(4, (0, _common.Param)('rowId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataTableController.prototype, "dataDelete", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v2/tables/:modelId/aggregate'
    ]),
    (0, _extractidsmiddleware.Acl)('dataAggregate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('modelId')),
    _ts_param(3, (0, _common.Query)('viewId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataTableController.prototype, "dataAggregate", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v2/tables/:modelId/bulk/group'
    ]),
    (0, _extractidsmiddleware.Acl)('dataGroupBy'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('modelId')),
    _ts_param(3, (0, _common.Query)('viewId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataTableController.prototype, "bulkGroupBy", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v2/tables/:modelId/bulk/datalist'
    ]),
    (0, _extractidsmiddleware.Acl)('dataList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('modelId')),
    _ts_param(3, (0, _common.Query)('viewId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataTableController.prototype, "bulkDataList", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v2/tables/:modelId/records/:rowId'
    ]),
    (0, _extractidsmiddleware.Acl)('dataRead'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('modelId')),
    _ts_param(3, (0, _common.Query)('viewId')),
    _ts_param(4, (0, _common.Param)('rowId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataTableController.prototype, "dataRead", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v2/tables/:modelId/records/:rowId/move'
    ]),
    (0, _extractidsmiddleware.Acl)('dataUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('modelId')),
    _ts_param(3, (0, _common.Param)('rowId')),
    _ts_param(4, (0, _common.Query)('before')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataTableController.prototype, "rowMove", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v2/tables/:modelId/links/:columnId/records/:rowId'
    ]),
    (0, _extractidsmiddleware.Acl)('nestedDataList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('modelId')),
    _ts_param(3, (0, _common.Query)('viewId')),
    _ts_param(4, (0, _common.Param)('columnId')),
    _ts_param(5, (0, _common.Param)('rowId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataTableController.prototype, "nestedDataList", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v2/tables/:modelId/links/:columnId/records/:rowId'
    ]),
    (0, _extractidsmiddleware.Acl)('nestedDataLink'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('modelId')),
    _ts_param(3, (0, _common.Query)('viewId')),
    _ts_param(4, (0, _common.Param)('columnId')),
    _ts_param(5, (0, _common.Param)('rowId')),
    _ts_param(6, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], DataTableController.prototype, "nestedLink", null);
_ts_decorate([
    (0, _common.Delete)([
        '/api/v2/tables/:modelId/links/:columnId/records/:rowId'
    ]),
    (0, _extractidsmiddleware.Acl)('nestedDataUnlink'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('modelId')),
    _ts_param(3, (0, _common.Query)('viewId')),
    _ts_param(4, (0, _common.Param)('columnId')),
    _ts_param(5, (0, _common.Param)('rowId')),
    _ts_param(6, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], DataTableController.prototype, "nestedUnlink", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v2/tables/:modelId/links/:columnId/records'
    ]),
    (0, _extractidsmiddleware.Acl)('nestedDataListCopyPasteOrDeleteAll'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('modelId')),
    _ts_param(3, (0, _common.Query)('viewId')),
    _ts_param(4, (0, _common.Param)('columnId')),
    _ts_param(5, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        Array
    ]),
    _ts_metadata("design:returntype", Promise)
], DataTableController.prototype, "nestedListCopyPasteOrDeleteAll", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v2/tables/:modelId/bulk/aggregate'
    ]),
    (0, _extractidsmiddleware.Acl)('dataAggregate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('modelId')),
    _ts_param(3, (0, _common.Query)('viewId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], DataTableController.prototype, "bulkAggregate", null);
DataTableController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_dataapilimiterguard.DataApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _datatableservice.DataTableService === "undefined" ? Object : _datatableservice.DataTableService
    ])
], DataTableController);
